import { render, staticRenderFns } from "./favorite-products.vue?vue&type=template&id=00d0d9e4&"
import script from "./favorite-products.ts?vue&type=script&lang=ts&"
export * from "./favorite-products.ts?vue&type=script&lang=ts&"
import style0 from "./favorite-products.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports